import React from 'react';

import { PrimaryButton, Avatar, Container, Row, Col } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import { CallCenter } from 'Jsx/CheckoutV4/types';

import Header from './components/Header/Header';

const PromotionExpired = ({ callCenter }: { callCenter?: CallCenter }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <Col>
          <Header />
        </Col>
      </Row>
      <Row
        className="flex items-center justify-center m-auto"
        style={{ height: '80vh' }}
      >
        <Col xs={12} md={6}>
          <h1 className="mb-8 text-center font-h3">
            {t('GREETING')}, {callCenter?.customerName}
          </h1>
          <p className="mb-24 text-center font-body2">
            {t('EXPIRATION_DESCRIPTION')}
          </p>
          <div className="flex items-center justify-center mt-8">
            <Avatar
              alt=""
              bgColor="gray-lighter"
              size={40}
              src={callCenter?.adviserPhoto}
            />
            <p className="font-body4 ml-16">{callCenter?.adviserName}</p>
          </div>
          <div className="flex mt-16">
            <PrimaryButton
              href="mailto:memberships@crehana.com"
              label={t('EXPIRATION_EMAIL_TAG')}
              className="m-auto"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PromotionExpired;
